// video.js エントリーポイント共通のユーティリティ関数。

/**
 * easytimer.js の Timer オブジェクトから閲覧時間（秒）を計算する。
 */
export function calc_viewing_time(timer) {
  const timeValues = timer.getTimeValues();
  return timeValues.hours * 3600
    + timeValues.minutes * 60
    + timeValues.seconds;
}
